(function(e) {
    "use strict";
    e.ajaxChimp = {
        responses: {
            "We have sent you a confirmation email": 0,
            "Please enter a value": 1,
            "An email address must contain a single @": 2,
            "The domain portion of the email address is invalid (the portion after the @: )": 3,
            "The username portion of the email address is invalid (the portion before the @: )": 4,
            "This email address looks fake or invalid. Please enter a real email address": 5
        },
        translations: {
            en: null
        },
        init: function(t, n) {
            e(t).ajaxChimp(n)
        }
    };
    e.fn.ajaxChimp = function(t) {
        e(this).each(function(n, r) {
            var i = e(r);
            var s = i.find("input[type=email]");
            var o = i.find("label[for=" + s.attr("id") + "]");
            var u = e.extend({
                url: i.attr("action"),
                language: "en"
            }, t);
            var a = u.url.replace("/post?", "/post-json?").concat("&c=?");
            i.attr("novalidate", "true");
            s.attr("name", "EMAIL");
            i.submit(function() {
                function t(t) {
                    if (t.result === "success") {
                        r = "We have sent you a confirmation email";
                        o.removeClass("error").addClass("valid");
                        s.removeClass("error").addClass("valid")
                    } else {
                        s.removeClass("valid").addClass("error");
                        o.removeClass("valid").addClass("error");
                        var n = -1;
                        var r;
                        try {
                            var i = t.msg.split(" - ", 2);
                            if (i[1] === undefined) {
                                r = t.msg
                            } else {
                                var a = parseInt(i[0], 10);
                                if (a.toString() === i[0]) {
                                    n = i[0];
                                    r = i[1]
                                } else {
                                    n = -1;
                                    r = t.msg
                                }
                            }
                        } catch (f) {
                            n = -1;
                            r = t.msg
                        }
                    }
                    if (u.language !== "en" && e.ajaxChimp.responses[r] && e.ajaxChimp.translations && e.ajaxChimp.translations[u.language] && e.ajaxChimp.translations[u.language][e.ajaxChimp.responses[r]]) {
                        r = e.ajaxChimp.translations[u.language][e.ajaxChimp.responses[r]]
                    }
                    o.html(r);
                    o.show(2e3);
                    if (u.callback) {
                        u.callback(t)
                    }
                }
                var n = {};
                var r = i.serializeArray();
                e.each(r, function(e, t) {
                    n[t.name] = t.value
                });
                e.ajax({
                    url: a,
                    data: n,
                    success: t,
                    dataType: "jsonp",
                    error: function(e, t) {
                        console.log("mailchimp ajax submit error: " + t)
                    }
                });
                var f = "Submitting...";
                if (u.language !== "en" && e.ajaxChimp.translations && e.ajaxChimp.translations[u.language] && e.ajaxChimp.translations[u.language]["submit"]) {
                    f = e.ajaxChimp.translations[u.language]["submit"]
                }
                o.html(f).show(2e3);
                return false
            })
        });
        return this
    }
})(jQuery)